import React, { useEffect, useState } from "react";
import {
  Stack,
  Typography,
  Button,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Radio,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { Navigate, useNavigate } from "react-router-dom";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import {
  startOverAPICall,
  stageDetailsAPICall,
  NRIGetsegmentDetailsAPICall,
  NRIUpdatesegmentDetailsAPICall,
  CommonDropDownAPICall,
} from "../shared/APICalls";
import routesData from "../shared/routes.json";
import TradingStyles from "../pages/Styles/TradingPreference.module.scss";
import StageLayout from "../Layouts/StageLayout";
import icon from "../Components/assets/Images/iconnew.svg";
import TickCircle from "../Components/assets/Images/tick-circle.svg";
import EmptyCircle from "../Components/assets/Images/TickEmptyCircle.svg";
import TradingDone from "../Components/assets/Images/doneicon.png";
import BackDrop from "../Components/BackDrop";
import StartOverBackDrop from "../Components/StartOverBackDrop";
import ErrorSnackBar from "../Components/SnackBars/ErrorSnackBar";
import { checkUserLoggedIn } from "../shared/commonfunctions";
import { confirmAlert } from "react-confirm-alert";
import keyboardicon from "../Components/assets/Images/tradingicongrey.svg";
import backicon from "../Components/assets/Images/back.svg";
import radiochecked from "../Components/assets/Images/radiochecked.svg";
import radiounchecked from "../Components/assets/Images/radiounchecked.svg";
import newcheckboxdone from "../Components/assets/Images/newcheckboxdone.svg";
import newcheckboxempty from "../Components/assets/Images/newcheckboxempty.svg";
import DoneOutlinedIcon from "@mui/icons-material/DoneOutlined";
import {
  setCompletedStages,
  setCurrentStage,
} from "../Components/redux/actions/pathNameActions";
import { useDispatch } from "react-redux";

const TradingPreferenceSchema = Yup.object().shape({
  Equity: Yup.boolean().oneOf([true], "Equity is required"),
});

export default function TradingPreference() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setloading] = useState(false);
  const [segmentData, setSegmentData] = useState<any>([]);

  const [prefilloading, setprefilloading] = useState(true);
  const [backdrop, setBackDrop] = useState(false);
  const [rejectMessage, setRejectMessage] = useState("");
  const [type, setType] = useState("NRO");

  const [prefillData, setprefillData] = useState<any>({
    equity: true,
    futures_and_options: true,
    currency: false,
    commodity: true,
    mutual_funds: true,
  });

  const navigationData = routesData;

  useEffect(() => {
    window.scrollTo(0, 0);
    checkUserLoggedIn(navigate);
    let dd_type = "segments";
    CommonDropDownAPICall(dd_type)
      .then((response: any) => {
        const responseData = response.data.data.segments;

        setSegmentData(
          responseData.filter(
            (a: any) =>
              a.segment_link !== "equity" && a.segment_link !== "mutual_funds"
          )
        );
      })
      .catch((error: any) => {});

    let obj: any = {
      stage: "segment",
    };

    stageDetailsAPICall(obj)
      .then((response: any) => {
        const responseData = response.data;
        dispatch(setCompletedStages(response.data.data.completed_stages));
        dispatch(setCurrentStage(response.data.data.current_stage));
        setprefilloading(false);

        // console.log("response", response.data.data.StageDetails);
        //  console.log("response", response.data.data.StageDetails.map((data: any) =>  data.IsOpted));
        setprefillData((prev) => {
          return {
            ...prev,
            equity: responseData?.data?.data?.filter(
              (a: any) => a.label === "equity"
            )[0]?.opted,
            futures_and_options: responseData?.data?.data?.filter(
              (a: any) => a.label === "futures_and_options"
            )[0]?.opted,
            // currency: responseData.data.StageDetails.CurrencyOpted,
            // commodity: responseData.data.StageDetails.CommodityOpted,
            mutual_funds: responseData?.data?.data?.filter(
              (a: any) => a.label === "mutual_funds"
            )[0]?.opted,
          };
        });
        if (responseData?.data?.data?.length) {
          if (
            responseData?.data?.data?.filter(
              (a: any) => a.label === "mutual_funds"
            )[0]?.opted ||
            responseData?.data?.data?.filter(
              (a: any) => a.label === "futures_and_options"
            )[0]?.opted
          ) {
            setType("NRO");
          } else {
            setType("NRE");
          }
        }
        if (response.data.data.ErrorMessage) {
          setRejectMessage(response.data.data.ErrorMessage);
        }
      })
      .catch((error: any) => {
        setprefilloading(false);
        // console.log("error", error);
      });
  }, []);

  function segmentDetailsPost(data: any) {
    console.log("data", data);
    setloading(true);

    let obj = {
      segment_list: {
        equity: {
          label: "equity",
          opted: true,
        },
        mutual_funds: {
          label: "mutual_funds",
          opted: true,
        },
        futures_and_options: {
          label: data[0].segment_link,
          opted: data[0].isOpted,
        },
      },
    };

    NRIUpdatesegmentDetailsAPICall(obj)
      .then((response: any) => {
        const responseData = response.data;
        // console.log("responseData", responseData);
        setloading(false);
        if (
          responseData.data.next_stage &&
          navigationData.hasOwnProperty(responseData.data.next_stage)
        ) {
          navigate(navigationData[responseData.data.next_stage]);
        }
      })
      .catch((error: any) => {
        setloading(false);
      });
  }

  const handleClick = () => {
    navigate("/yourprofile");
  };
  //console.log(prefillData.mutual_funds);

  const handleStartOver = () => {
    confirmAlert({
      title: "",
      message:
        "Are you sure you want to restart, on pressing Yes all the Data will be deleted",
      buttons: [
        {
          label: "No",
          onClick: () => "",
        },
        {
          label: "Yes",
          onClick: () => {
            setBackDrop(true);
            startOverAPICall()
              .then((response: any) => {
                const responseData = response.data;
                // console.log("responseData", response);
                setBackDrop(false);
                navigate("/");
                window.location.reload();
              })
              .catch((error: any) => {
                setBackDrop(false);
              });
          },
        },
      ],
    });
  };

  const InitialValues = {
    equity: true,
    futures_and_options: prefillData.futures_and_options,
    // currency: !prefillData.currency,
    // commodity: prefillData.commodity,
    mutual_funds: prefillData.mutual_funds,
  };

  //console.log(selectedCheckboxes);

  const handleCheckBoxClick = (name: any, callback: any, values: any) => {
    callback(name, !values[name]);
  };
  // console.log("segmentData", segmentData);
  return (
    <div className={TradingStyles.mainWrapper}>
      <ErrorSnackBar message={rejectMessage} />
      <div className={TradingStyles.wrapper}>
        <div
          className={TradingStyles.backTop}
          onClick={() => {
            navigate("/mobile");
          }}
        >
          <img src={backicon} />{" "}
          <span className={TradingStyles.backText}>Back</span>
        </div>
        <div className={TradingStyles.step}>
          <img src={keyboardicon} /> Step 4 of 10
        </div>
        <div className={TradingStyles.headerSection}>
          <p className={TradingStyles.signup}>Trading Preference</p>
          <p className={TradingStyles.subText}>
            Selection of Type of Account -  NRO Non PIS and NRE PIS with
            instructions and Document required
          </p>
        </div>
        {!prefilloading ? (
          <Formik
            initialValues={InitialValues}
            validationSchema={TradingPreferenceSchema}
            onSubmit={(values) => {
              // console.log("vlaue", values);
              const selectedSegments = segmentData
                .filter((segment: any) => values[segment.segment_link])
                .map((segment: any) => ({
                  segmentName: segment.value,

                  segmentLink: segment.segment_link,
                }));

              const updatedSegmentData = segmentData.map((a: any) => {
                const isOpted = selectedSegments.some(
                  (b: any) => b.segmentLink === a.segment_link
                );
                return { ...a, isOpted };
              });
              segmentDetailsPost(updatedSegmentData);
            }}
          >
            {({ errors, touched, handleSubmit, setFieldValue, values }) => {
              // console.log("values", values);
              return (
                <Form
                  onKeyDown={(event) => {
                    event.code === "Enter" ||
                      (event.code === "NumpadEnter" && handleSubmit());
                  }}
                  style={{ width: "100%" }}
                >
                  <Stack alignItems={"center"}>
                    <Stack
                      marginTop={"10px"}
                      width={"100%"}
                      alignItems={"center"}
                    >
                      <div className={TradingStyles.radioContainer}>
                        <div
                          className={TradingStyles.radioLeft}
                          onClick={() => {
                            setType("NRO");
                          }}
                          style={{
                            border: type === "NRO" ? "1px solid #374151" : "",
                            background: type === "NRO" ? "" : "#FFF",
                          }}
                        >
                          <img
                            src={type === "NRO" ? radiochecked : radiounchecked}
                            style={{ marginBottom: "-3px" }}
                          />
                          <p className={TradingStyles.lebeltext}>NRO NON PIS</p>
                        </div>
                        {/* <div
                          className={TradingStyles.radioLeft}
                          onClick={() => {
                            setType("NRE");
                            setFieldValue("mutual_funds", false);
                            setFieldValue("futures_and_options", false);
                          }}
                          style={{
                            border: type === "NRE" ? "1px solid #374151" : "",
                            background: type === "NRE" ? "" : "#FFF",
                          }}
                        >
                          <img
                            src={type === "NRE" ? radiochecked : radiounchecked}
                            style={{ marginBottom: "-3px" }}
                          />
                          <p className={TradingStyles.lebeltext}>NRE PIS</p>
                        </div> */}
                      </div>
                      <div className={TradingStyles.optionsWrapper}>
                        <div
                          className={TradingStyles.checkBoxFeild}
                          style={{
                            background: "#F9FAFB",
                            border: "1px solid #374151",
                            cursor: "not-allowed",
                          }}
                        >
                          <FormControlLabel
                            sx={{
                              marginRight: "10px",
                              width: "100%",
                              cursor: "not-allowed",
                            }}
                            control={
                              <Checkbox
                                icon={
                                  <img
                                    src={newcheckboxdone}
                                    style={{
                                      width: "35px",
                                      height: "35px",
                                      marginBottom: "-2px",
                                    }}
                                  />
                                }
                                checkedIcon={
                                  <img
                                    src={newcheckboxdone}
                                    style={{
                                      width: "35px",
                                      height: "35px",
                                      marginBottom: "-2px",
                                    }}
                                  />
                                }
                                name={"equity"}
                                //disabled={segment.segmentLink === "equity"}
                                style={{
                                  height: "20px",
                                  width: "20px",
                                  cursor: "not-allowed",
                                }}
                                checked
                              />
                            }
                            label={
                              <div className={TradingStyles.radiolabel}>
                                Equity
                              </div>
                            }
                          />
                          {/* 
                          <span className={TradingStyles.defaultLabel}>
                            Default
                          </span> */}
                        </div>
                        <div
                          className={TradingStyles.checkBoxFeild}
                          style={{
                            background: "#F9FAFB",
                            border: "1px solid #374151",
                            cursor: "not-allowed",
                          }}
                        >
                          <FormControlLabel
                            sx={{
                              marginRight: "10px",
                              width: "100%",
                              cursor: "not-allowed",
                            }}
                            control={
                              <Checkbox
                                icon={
                                  <img
                                    src={newcheckboxdone}
                                    style={{
                                      width: "35px",
                                      height: "35px",
                                      marginBottom: "-2px",
                                    }}
                                  />
                                }
                                checkedIcon={
                                  <img
                                    src={newcheckboxdone}
                                    style={{
                                      width: "35px",
                                      height: "35px",
                                      marginBottom: "-2px",
                                    }}
                                  />
                                }
                                name={"equity"}
                                //disabled={segment.segmentLink === "equity"}
                                style={{
                                  height: "20px",
                                  width: "20px",
                                  cursor: "not-allowed",
                                }}
                                checked
                              />
                            }
                            label={
                              <div className={TradingStyles.radiolabel}>
                                Mutual Funds
                              </div>
                            }
                          />
                          {/* 
                          <span className={TradingStyles.defaultLabel}>
                            Default
                          </span> */}
                        </div>
                        {type === "NRO" && (
                          <FormGroup
                            sx={{
                              display: "flex",
                              flexDirection: "row",
                              justifyContent: "center",
                              gap: { xs: "10px", sm: "20px" },
                            }}
                          >
                            {segmentData.map((segment: any, index: any) => (
                              <div
                                className={TradingStyles.checkBoxFeild}
                                style={{
                                  background: values[segment.segment_link]
                                    ? "#F9FAFB"
                                    : "#F8F9FB",
                                  border: values[segment.segment_link]
                                    ? "1px solid #374151"
                                    : "",
                                }}
                                key={segment.segment_link}
                              >
                                <FormControlLabel
                                  sx={{ marginRight: "10px" }}
                                  control={
                                    <Checkbox
                                      icon={
                                        values[segment.segment_link] ===
                                        true ? (
                                          <img
                                            src={newcheckboxdone}
                                            style={{
                                              width: "35px",
                                              height: "35px",
                                              marginBottom: "-2px",
                                            }}
                                          />
                                        ) : (
                                          <img
                                            src={newcheckboxempty}
                                            style={{
                                              width: "35px",
                                              height: "35px",
                                              marginBottom: "-2px",
                                            }}
                                          />
                                        )
                                      }
                                      checkedIcon={
                                        values[segment.segment_link] ===
                                        "equity" ? (
                                          <img
                                            src={newcheckboxdone}
                                            style={{
                                              width: "35px",
                                              height: "35px",
                                              marginBottom: "-2px",
                                            }}
                                          />
                                        ) : (
                                          <img
                                            src={newcheckboxdone}
                                            style={{
                                              width: "35px",
                                              height: "35px",
                                              marginBottom: "-2px",
                                            }}
                                          />
                                        )
                                      }
                                      name={segment.segment_link}
                                      onClick={(e) => {
                                        if (segment.segment_link !== "equity") {
                                          e.stopPropagation();
                                          handleCheckBoxClick(
                                            segment.segment_link,
                                            setFieldValue,
                                            values
                                          );
                                        }
                                      }}
                                      //disabled={segment.segmentLink === "equity"}
                                      style={{ height: "20px", width: "20px" }}
                                      value={values[segment.segment_link]}
                                      checked={values[segment.segment_link]}
                                    />
                                  }
                                  label={
                                    <div className={TradingStyles.radiolabel}>
                                      {segment.value}
                                    </div>
                                  }
                                />
                                {segment.segmentLink === "equity" && (
                                  <span className={TradingStyles.defaultLabel}>
                                    Default
                                  </span>
                                )}
                              </div>
                            ))}
                          </FormGroup>
                        )}
                      </div>
                    </Stack>
                    {backdrop && <StartOverBackDrop />}

                    <div className={TradingStyles.instructionsSection}>
                      <p className={TradingStyles.instructions}>
                        Documents Required for KYC Validation{" "}
                      </p>
                      <div className={TradingStyles.pointsSection}>
                        <p className={TradingStyles.point}>
                          {" "}
                          <DoneOutlinedIcon style={{ color: "#049981" }} /> PAN
                          Card Copy{" "}
                        </p>

                        {type === "NRO" && values.futures_and_options && (
                          <p className={TradingStyles.point}>
                            {" "}
                            <DoneOutlinedIcon
                              style={{ color: "#049981" }}
                            />{" "}
                            Passport copy of client with immigration page{" "}
                          </p>
                        )}
                        <p className={TradingStyles.point}>
                          {" "}
                          <DoneOutlinedIcon style={{ color: "#049981" }} />{" "}
                          Foreign address proof - Latest Bank Statement of a
                          foreign bank account{" "}
                        </p>
                        <p className={TradingStyles.point}>
                          {" "}
                          <DoneOutlinedIcon style={{ color: "#049981" }} />
                          VISA copy{" "}
                        </p>

                        <p className={TradingStyles.point}>
                          {" "}
                          <DoneOutlinedIcon style={{ color: "#049981" }} />
                          {type === "NRO"
                            ? "NRO Bank account"
                            : "NRO Bank account"}{" "}
                        </p>
                        {type === "NRE" && (
                          <p className={TradingStyles.point}>
                            {" "}
                            <DoneOutlinedIcon
                              style={{ color: "#049981" }}
                            />{" "}
                            PIS Bank account{" "}
                          </p>
                        )}
                      </div>
                    </div>

                    <div className={TradingStyles.buttonStack}>
                      <div
                        style={{
                          width: "100%",
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        <LoadingButton
                          id="tradingPreferencesContinueButton"
                          variant="contained"
                          // type="submit"
                          onClick={() => {
                            handleSubmit();
                          }}
                          sx={{ height: "50px" }}
                          className={TradingStyles.approveButton}
                        >
                          Continue
                        </LoadingButton>
                      </div>
                      {/* <div className={TradingStyles.startOverSection}>
                        <img src={icon} className={TradingStyles.iconImage} />
                        <p className={TradingStyles.paratext}>
                          {" "}
                          if the above mentioned info not yours
                          <span
                            className={TradingStyles.startoverbutton}
                            onClick={handleStartOver}
                          >
                            Start Over
                          </span>
                        </p>
                      </div> */}
                    </div>
                  </Stack>
                </Form>
              );
            }}
          </Formik>
        ) : (
          <div className={TradingStyles.wrapper}>
            <BackDrop />
          </div>
        )}
      </div>
    </div>
  );
}
